module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "copyrightPage",
    attrs: {
      "id": "copyrightPage"
    }
  }, [_c('p', {
    staticClass: "copyrightText"
  }, [_vm._v("Published in the United States of America and Great Britain in 2011 by")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText1"
  }, [_vm._v("CASEMATE PUBLISHERS")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText1"
  }, [_vm._v("908 Darby Road, Havertown, PA 19083")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText1"
  }, [_vm._v("and")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText1"
  }, [_vm._v("17 Cheap Street, Newbury RG14 5DD")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText2"
  }, [_vm._v("Copyright 2011 © Alan D. Zimm")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText2"
  }, [_vm._v("ISBN 978-1-61200-010-7")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText1"
  }, [_vm._v("Digital Edition: ISBN 978-1-61200-021-3")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText2"
  }, [_vm._v("Cataloging-in-publication data is available from the Library of Congress and the British Library.")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText2"
  }, [_vm._v("All rights reserved. No part of this book may be reproduced or transmitted in any form or by any means, electronic or mechanical including photocopying, recording or by any information storage and retrieval system, without permission from the Publisher in writing.")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText2"
  }, [_vm._v("10 9 8 7 6 5 4 3 2 1")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText2"
  }, [_vm._v("Printed and bound in the United States of America.")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText2"
  }, [_vm._v("For a complete list of Casemate titles please contact:")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText2"
  }, [_vm._v("CASEMATE PUBLISHERS (US)")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText1"
  }, [_vm._v("Telephone (610) 853-9131, Fax (610) 853-9146")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText1"
  }, [_vm._v("E-mail: casemate@casematepublishing.com")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText2"
  }, [_vm._v("CASEMATE PUBLISHERS (UK)")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText1"
  }, [_vm._v("Telephone (01635) 231091, Fax (01635) 41619")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText1"
  }, [_vm._v("E-mail: casemate-uk@casematepublishing.co.uk")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b829a1d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AttackonPearlHarbor_copyright.vue
// module id = 63
// module chunks = 0